/**
 * This module contains the ability to route to the MyGroup
 * @description Registers routes to UI components, links
 */

import React from 'react';
import { getTelemetry } from '../Telemetry/Telemetry';
import { ErrorBoundaryPage } from '../Application/Page';

const AsyncGroups = React.lazy(() =>
  import('./Groups')
    .then((loaded) => {
      return {
        default: loaded.ConnectedGroupsPage,
      };
    })
    .catch((err) => {
      const telemetry = getTelemetry();
      telemetry.error('resourceError/AsyncGroups', `Failed to get bundle. Error details:  ${err}`);
      throw err;
    }),
);

export const GroupsPage = () => {
  return (
    <ErrorBoundaryPage>
      <AsyncGroups />
    </ErrorBoundaryPage>
  );
};
